<template>
  <div class="header">
    <div class="header-wrapper">
      <button class="btn-menu" @click.prevent="openSidebar" v-if="!isSoftbank">
        <img src="@/assets/img/ico_menu.png" alt="ico_menu">
      </button>
      <a @click.prevent="onClickLogo" class="header-logo">
        <img src="@/assets/img/ico_logo_zengo.svg"/>
      </a>
      <div class="header-login" v-if="!isLogin && isTop">
        <router-link class="btn-login" :to="{name: 'Login'}" tag="button">ログイン</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {API_GET_USER_INFO} from '@/configs/api'
import apiService from '@/services/apiService'

export default {
  name: 'MainHeader',
  props: {
    isTop: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
    }),
    logoRoute () {
      return (this.userInfo && this.userInfo.user_id) ? 'ProjectList' : 'TOP';
    },
    isLogin () {
      return (this.userInfo && this.userInfo.user_id)
    },
    isSoftbank () {
      return this.$route.meta.isSoftbank ? this.$route.meta.isSoftbank : false;
    },
  },
  methods: {
    async openSidebar () {
      if (this.isLogin) {
        let response = await apiService.postWithoutIsCallingFlag(API_GET_USER_INFO, {
          user_id: this.userInfo.user_id,
        });
        if (response.data && response.data.code === 200) {
          this.$store.commit('SET_USER_INFO', response.data.user_info);
          this.$emit('openSidebar', true)
        }
      } else {
        this.$emit('openSidebar', true)
      }
    },
    onClickLogo () {
      let nameRouter = '';
      let paramRouter = {};
      if (this.userInfo && this.userInfo.user_id) {
        if (this.userInfo.account_level === this.$constant.ADMIN_LEVEL) {
          nameRouter = 'ManagerConstruction'
        } else if (this.userInfo.account_level === this.$constant.SUPERVISOR_LEVEL) {
          nameRouter = 'ListConstruction';
          paramRouter = {manager_user_id: this.userInfo.user_id}
        } else {
          nameRouter = 'ProjectList'
        }
      } else {
        nameRouter = 'TOP';
      }
      nameRouter === this.$route.name ? this.$router.go() : this.$router.push({name: nameRouter,
        params: paramRouter})
    }
  },
  watch: {
    userInfo (newValue, oldValue) {
      if (newValue.status === this.$constant.USER.SUSPEND_USER) {
        this.$store.dispatch('logout')
        this.$router.push({name: 'Login'})
      }
    },
  },
}
</script>

<style scoped>
.header-wrapper .header-login {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
}

.header-wrapper .header-login .btn-login {
  position: relative;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  width: 96px;
  height: 60px;
  overflow: hidden;
  background: none;
  border: 0;
  z-index: 1;
  padding-left: 15px;
}

.header-wrapper .header-login .btn-login:before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 2px;
  width: 110px;
  height: 120px;
  transform: rotate(10deg) translateY(-40%);
  background: #14100E;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MainHeader.vue